import * as React from 'react';
import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../reducers';
import {
    getMediaGallery,
    increaseFrequency
} from '../../../../../services/media.service';
import MediaItem from '../MediaItem';
import {
    UilArrowLeft,
    UilArrowRight,
    UilSearch
} from '@iconscout/react-unicons';
interface MediaGalleryProps {
    mediaGallery: any[];
    type: string;
    applyCurrentMedia?: (data: {
        mediaURL: string;
        label?: string;
        type?: string;
    }) => void;
    setLoading: (toggle: boolean) => void;
    getMediaGallery: () => Promise<any>;
    increaseFrequency: (id: number) => void;
}

const ITEM_PER_PAGE = 9;

const MediaGallery: React.FC<MediaGalleryProps> = ({
    mediaGallery,
    type,
    setLoading,
    getMediaGallery,
    applyCurrentMedia,
    increaseFrequency
}: MediaGalleryProps) => {
    const [pageIndex, setPageIndex] = React.useState(1);
    const [searchString, setSearchString] = React.useState('');
    const [activeMediaId, setActiveMediaId] = React.useState(null);
    const activeMediaRef = React.useRef();
    const mediaGalleryFilteredByType = mediaGallery.filter((media) => {
        if (type === 'default') return true;

        return media.type === type;
    });

    const searchMediaGallery = searchString
        ? mediaGalleryFilteredByType.filter(
              (media) =>
                  media.label
                      ?.toLowerCase()
                      .indexOf(searchString.toLowerCase()) > -1
          )
        : mediaGalleryFilteredByType;

    const totalPage = Math.ceil(searchMediaGallery?.length / ITEM_PER_PAGE);

    React.useEffect(() => {
        async function fetchMediaGallery() {
            try {
                await getMediaGallery();
            } catch (err) {}
        }
        if (!mediaGallery.length) {
            fetchMediaGallery();
        }

        return () => {
            const mediaId = activeMediaRef.current;
            mediaId && increaseFrequency(mediaId);
        };
    }, []);

    React.useEffect(() => {
        activeMediaRef.current = activeMediaId;
    }, [activeMediaId]);

    React.useEffect(() => {
        setPageIndex(1);
    }, [searchString]);

    const handleActiveMedia = (mediaId, mediaURL, label?, type?) => {
        setActiveMediaId(mediaId);
        applyCurrentMedia({ mediaURL, label, type });
    };
    const handlePreviousPage = () => {
        if (pageIndex > 1) {
            setLoading(true);

            setTimeout(() => {
                setPageIndex((index) => index - 1);
                setLoading(false);
            }, 500);
        }
    };

    const handleNextPage = () => {
        if (pageIndex < totalPage) {
            setLoading(true);

            setTimeout(() => {
                setPageIndex((index) => index + 1);
                setLoading(false);
            }, 500);
        }
    };

    const handlePageByIndex = (index) => {
        if (index >= 1 && index <= totalPage) {
            setLoading(true);
            setTimeout(() => {
                setPageIndex(index);
                setLoading(false);
            }, 500);
        }
    };

    const filteredMediaGallery = searchMediaGallery?.filter(
        (media, index) =>
            index + 1 <= ITEM_PER_PAGE * pageIndex &&
            ITEM_PER_PAGE * (pageIndex - 1) <= index
    );
    return (
        <div>
            <div className="media--gallery--search">
                <input
                    type="text"
                    placeholder="Start typing to search"
                    onChange={(e) => setSearchString(e.target.value)}
                />
                <UilSearch size={20} />
            </div>
            <div className="media-item--container">
                {filteredMediaGallery?.map((m) => (
                    <MediaItem
                        media={m}
                        key={m?.mediaId}
                        applyCurrentMedia={() =>
                            handleActiveMedia(
                                m.mediaId,
                                m.mediaURL,
                                m.label,
                                m.type
                            )
                        }
                        active={activeMediaId === m.mediaId}
                        editEnable
                    />
                ))}
            </div>
            <div className="media--gallery--pagination">
                <span onClick={handlePreviousPage}>
                    <UilArrowLeft size={20} />{' '}
                </span>
                <input
                    type="number"
                    min={1}
                    max={totalPage}
                    defaultValue={pageIndex}
                    value={pageIndex}
                    onChange={(e) =>
                        handlePageByIndex(parseInt(e.target.value))
                    }
                />
                <span>/</span> <span>{totalPage}</span>
                <span onClick={handleNextPage}>
                    <UilArrowRight size={20} />{' '}
                </span>
            </div>
        </div>
    );
};

const mapStateToProps = ({ mediaReducer }: IApplicationState) => ({
    mediaGallery: mediaReducer.medias
});

const mapDispatchToProps = (dispatch) => ({
    getMediaGallery: () => dispatch(getMediaGallery()),
    increaseFrequency: (id: number) => dispatch(increaseFrequency(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(MediaGallery);
